export const BiasTestIdToVideoLinkRecord: Record<number, string> = {
  0: 'https://www.youtube.com/embed/vh2KRVO3VcA',
  1: 'https://www.youtube.com/embed/kqCoy6sklJA',
  2: 'https://www.youtube.com/embed/kqCoy6sklJA',
  3: 'https://www.youtube.com/embed/ty5NBpSWXkw',
  4: 'https://www.youtube.com/embed/gXrh9OmQXUg',
  5: 'https://www.youtube.com/embed/UMOjz6fn2Wo',
  6: 'https://www.youtube.com/embed/vh2KRVO3VcA',
  7: 'https://www.youtube.com/embed/V5azyiAxcfQ',
  8: 'https://www.youtube.com/embed/M8tC3omGIEI',
  9: 'https://www.youtube.com/embed/q7EhYy84ml8',
  10: 'https://www.youtube.com/embed/kqCoy6sklJA',
  11: 'https://www.youtube.com/embed/gXrh9OmQXUg',
  12: 'https://www.youtube.com/embed/gXrh9OmQXUg',
};
